/* Native scroll snapping supports touch; controls also work with a keyboard. */
(() => {
  if (customElements.get('product-gallery')) return;
  customElements.define('product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.track = this.querySelector('.product-card__slides');
      this.slides = [...this.querySelectorAll('.product-card__slide')];
      this.index = 0;
      if (this.slides.length < 2) return;
      const go = direction => {
        const next = (this.index + direction + this.slides.length) % this.slides.length;
        this.track.scrollTo({left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => go(-1), options);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => go(1), options);
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
  this.addEventListener('mouseleave', () => {
    if (this.index !== 0) go(-this.index);
  }, options);
}
      this.track.addEventListener('scroll', () => {
        this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        const moveFocus = this.slides.includes(document.activeElement);
        this.slides.forEach((slide, index) => {
          slide.tabIndex = index === this.index ? 0 : -1;
          slide.setAttribute('aria-hidden', String(index !== this.index));
        });
        this.querySelector('[data-gallery-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
        if (moveFocus) this.slides[this.index]?.focus({preventScroll:true});
      }, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); go(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.resize = new ResizeObserver(() => this.track.scrollTo({left:this.index * this.track.clientWidth,behavior:'instant'}));
      this.resize.observe(this.track);
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.abort = null; }
  });
})();
